import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/talk-more-icon.png'
import _imports_1 from '@/assets/img/no-image.png'
import _imports_2 from '@/assets/img/pickup-button-vector.png'


const _hoisted_1 = { class: "other-talent" }
const _hoisted_2 = { class: "other-talent-headline-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "txt txt-headline other-talent-headline" }, "他のタレントを見る", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "talk-more-text txt" }, "もっと見る", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "talk-more-icon",
  src: _imports_0
}, null, -1)
const _hoisted_6 = { class: "other-talent-list" }
const _hoisted_7 = {
  key: 0,
  class: "other-talent-img",
  src: _imports_1
}
const _hoisted_8 = {
  key: 2,
  class: "next-live-box"
}
const _hoisted_9 = { class: "next-live-text txt txt-wt txt-detail" }
const _hoisted_10 = { class: "talent-name txt txt-small" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "other-talent-circle" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "other-talent-circle-vector",
    src: _imports_2
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Imgix = _resolveComponent("Imgix")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        class: "talk-more-box",
        to: { name: 'TalkFutureTalentsScreen' }
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.otherTalents, (otherTalent, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "other-talent-box",
          onClick: ($event: any) => (_ctx.openTalent(otherTalent.talentID))
        }, [
          (otherTalent.mainImage === '')
            ? (_openBlock(), _createBlock("img", _hoisted_7))
            : (_openBlock(), _createBlock(_component_Imgix, {
                key: 1,
                class: "other-talent-img",
                imageUrl: otherTalent.mainImage,
                imageSize: _ctx.imageSize
              }, null, 8, ["imageUrl", "imageSize"])),
          (otherTalent.liveStatus === 3)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode(_component_font_awesome_icon, {
                  class: "next-live-icon",
                  icon: ['far', 'clock']
                }),
                _createVNode("div", _hoisted_9, _toDisplayString(otherTalent.convertUnixToDate), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_10, _toDisplayString(otherTalent.formatDisplayNameOfTalkFutureTalents), 1)
        ], 8, ["onClick"]))
      }), 256))
    ]),
    _hoisted_11
  ]))
}